export const Synergy = ({ width = 20, height = 20, ...props }: any) => (
  <img src="/icons/Synergy.svg" alt="Synergy" width={width} height={height} {...props} />
)
